var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('button',{staticClass:"loading",class:_vm.styling,attrs:{"id":_vm.id}},[_c('span',[_vm._v(_vm._s(_vm.buttonText))])]):_c('button',{class:_vm.styling,attrs:{"disabled":_vm.disabled,"id":_vm.id},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }